export function CategoryRail({ categories, active, onPick }) {
    if (!categories?.length) return null;
    return (
        <section className="border-y border-border bg-secondary overflow-x-auto" data-testid="category-rail">
            <div className="flex min-w-max">
                <button
                    onClick={() => onPick("All")}
                    className={`px-6 py-5 font-mono-label text-xs border-r border-border whitespace-nowrap hover-invert ${
                        active === "All" ? "bg-foreground text-background" : "bg-background"
                    }`}
                    data-testid="cat-all"
                >
                    All <span className="text-muted-foreground ml-2">∑</span>
                </button>
                {categories.map((c) => (
                    <button
                        key={c.name}
                        onClick={() => onPick(c.name)}
                        className={`px-6 py-5 font-mono-label text-xs border-r border-border whitespace-nowrap hover-invert ${
                            active === c.name ? "bg-foreground text-background" : "bg-background"
                        }`}
                        data-testid={`cat-${c.name}`}
                    >
                        {c.name}{" "}
                        <span className={`ml-2 ${active === c.name ? "text-background/60" : "text-muted-foreground"}`}>
                            {c.count}
                        </span>
                    </button>
                ))}
            </div>
        </section>
    );
}
